import { SecondaryButton, stenaTimesCircle } from '@stenajs-webui/elements';
import type { ReactNode } from 'react';
import { CancelPanelBase } from './CancelPanelBase';

import { FreightPortalControlledPopover } from './popover/FreightPortalControlledPopover';

interface CancelButtonWithPopoverProps {
  children: ReactNode;
  disabled: boolean | undefined;
  onAbort: () => void;
  onClick: () => void;
  onConfirm: () => void;
  onRequestClose: () => void;
  submitting: boolean;
  visible: boolean;
}

export const CancelButtonWithPopover = ({
  children,
  disabled,
  onAbort,
  onClick,
  onConfirm,
  onRequestClose,
  submitting,
  visible,
}: CancelButtonWithPopoverProps) => {
  return (
    <FreightPortalControlledPopover
      renderTrigger={props => (
        <SecondaryButton
          variant={'danger'}
          label={'Cancel booking'}
          className={'t_booking_details_cancel_link'}
          onClick={onClick}
          leftIcon={stenaTimesCircle}
          disabled={disabled}
          {...props}
        />
      )}
      onRequestClose={onRequestClose}
      open={visible}
    >
      <CancelPanelBase
        onClose={onRequestClose}
        submitting={submitting}
        onConfirm={onConfirm}
        onAbort={onAbort}
      >
        {children}
      </CancelPanelBase>
    </FreightPortalControlledPopover>
  );
};
